import { useEffect } from 'react'

/* Zet `document.title` op `<paginanaam> · <site>`, en herstelt de vorige titel
   wanneer de component weer weg is. Zo hebben browser-tabs herkenbare titels
   in plaats van allemaal "LAN Server". */

function siteNaamUitBranding() {
  try {
    const raw = sessionStorage.getItem('brandingCache')
    if (raw) {
      const b = JSON.parse(raw)
      if (b?.site_name) return b.site_name
    }
  } catch {}
  return 'LAN Server'
}

export default function usePageTitle(paginaTitel) {
  useEffect(() => {
    if (!paginaTitel) return
    const vorige = document.title
    const site = siteNaamUitBranding()
    document.title = `${paginaTitel} · ${site}`
    return () => { document.title = vorige }
  }, [paginaTitel])
}
